import {
  type BlockDeletionOutcome,
  deleteSelectedModelsCommand,
} from '@blocksuite/affine-shared/commands';
import type { Store } from '@blocksuite/store';

/** Await the existing page gate before an AI patch can replace or remove a block. */
export async function deleteBlockFromPage(
  doc: Store,
  id: string
): Promise<boolean> {
  const model = doc.getModelById(id);
  if (!model) return false;
  let results!: Promise<BlockDeletionOutcome[]>;
  deleteSelectedModelsCommand(
    { store: doc, selectedModels: [model] },
    output => {
      results = output.deletionResults;
    }
  );
  const [outcome] = await results;
  return outcome === 'deleted';
}
